module.exports = __webpack_public_path__ + "img/arrow-left.94a7847f.svg";